import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(private swUpdate: SwUpdate) {
    if(swUpdate.isEnabled) {      
      setInterval(() => {        
        swUpdate.checkForUpdate();
      }, 60000);

      swUpdate.available.subscribe(() => {
        console.log('New version available. Reloading...');        
        window.location.reload();
      })
    }
   }
}
